<script lang="ts" setup>
  import { useVerifiedCart } from '@storefront/storefront';

  const cart = useVerifiedCart();
</script>
<template>
  <div v-if="cart.shippingOptionName" class="shipping-option-summary">
    <SfIconTruck aria-hidden="true" class="shipping-option-summary__icon" />
    <div class="shipping-option-summary__content">
      <span class="shipping-option-summary__property">{{ $t('SHOP.ORDER.LABEL.SHIPPING_METHOD') }}</span>
      <span class="shipping-option-summary__value">{{ cart.shippingOptionName }}</span>
    </div>
  </div>
</template>
<style lang="scss">
  @use "@storefront/styles/mixins/media";

  .shipping-option-summary {
    display: flex;
    gap: 0.75rem;
    padding: 0.75rem 1.5rem;

    &__icon {
      font-size: 1.25rem;
    }

    &__content {
      display: flex;
      flex-direction: column;
    }

    &__value {
      font-weight: var(--font-weight-semi);
    }

    @include media.query(xl) {
      padding: 0.5rem 1rem;
    }
  }
</style>
